<template>
  <v-card><v-card-text>{{$route.params.id}}</v-card-text></v-card>
</template>

<script>
export default {
  name: "show"
}
</script>

<style scoped>

</style>